export const common = {
  // Navbar
  "nav.home": "Home",
  "nav.about": "About Us",
  "nav.services": "Products",
  "nav.portfolio": "Solutions",
  "nav.contact": "Contact",
  "nav.startInvesting": "Get a Quote",
  "nav.investment": "Alebel Investment",
  "nav.investmentDesc": "Parent Holding Group",
  "nav.robotics": "Alebel Robotics",
  "nav.roboticsDesc": "Robotics & Automation",

  // Hero
  "hero.badge": "Future Forward Batteries",
  "hero.title1": "Engineered Around",
  "hero.title2": "Your Power Needs",
  "hero.subtitle": "Next-Generation Lithium Battery Systems",
  "hero.description": "We don't just build batteries — we engineer the energy infrastructure of tomorrow. High-performance systems built for industries that cannot afford to stop.",
  "hero.discoverMore": "Explore Solutions",
  "hero.getInTouch": "Get a Quote",
  "hero.portfolioCompanies": "Charge Cycles",
  "hero.headquarters": "Headquarters",
  "hero.established": "Established",
  "hero.strategicGrowth": "High Energy Efficiency",
  "hero.valueCreation": "Long Lifecycle Performance",
  "hero.scroll": "Scroll",
  "hero.uae": "UAE",


  // About
  "about.label": "About Us",
  "about.title1": "Advanced Energy",
  "about.title2": "Solutions",
  "about.description": "We build the energy systems that power the world's most critical infrastructure — engineered for precision, designed for the future.",  
  "about.parentEntity": "Engineering Excellence",
  "about.parentEntityDesc": "Complete end-to-end engineering capability from cell selection and BMS integration to mechanical design, testing, and full system integration. We deliver precision-built lithium battery solutions customized for performance, safety, reliability, and customer-specific application requirements.",
  "about.uaeBased": "UAE Based",
  "about.uaeBasedDesc": "Headquartered in Dubai, ALEBEL ENERGY serves telecom, industrial, logistics, renewable energy, mobility, and data center sectors across the UAE and regional markets with advanced customized lithium battery solutions and local technical support.",
  "about.activeOwnership": "Quality & Safety",
  "about.activeOwnershipDesc": "Every battery system undergoes rigorous charge/discharge testing, thermal performance testing, load testing, and BMS protection verification to ensure maximum safety, reliability, and stable performance. Our systems are designed with advanced protections for over-voltage, over-current, short-circuit, and temperature control to meet demanding industrial and telecom application standards.",
  "about.innovationFocus": "Smart Technology",
  "about.innovationFocusDesc": "IoT-ready battery systems with real-time monitoring and controlling capabilities, featuring CAN Bus, RS485, Bluetooth, smart BMS integration, and advanced CCS technology for reliable high-current connectivity and system safety. Our solutions support remote monitoring, alarm notifications, performance tracking, and TFT display integration for intelligent and efficient battery operation.",
  "about.investmentSectors": "Industries We Serve",
  "about.learnMore": "Learn More About Us",
  "about.ceoQuote1": "At Alebel Energy, our mission is to deliver world-class lithium battery systems designed to meet the highest standards of performance, efficiency, and reliability.",
  "about.ceoQuote2": "We provide fully customizable energy solutions tailored to the unique needs of different industries, ensuring maximum safety and dependable operation in every application.",
  "about.mhbm": "MHBM",
  "about.ceoName": "Mohamed Hamad Bin Mnaidherh",
  "about.ceoTitle": "CEO",
  "about.alebelteam": "Alebel Energy Team",
  "aboutPage.story.heading1": "Engineering the",   
  "aboutPage.story.heading2": "Energy Future",

  // Sectors
  "sector.energy": "Telecom Infrastructure",
  "sector.technology": "Industrial Applications",
  "sector.manufacturing": "Logistics & Material Handling",
  "sector.electronics": "Renewable Energy",
  "sector.industrial": "Electric Mobility",

  // Services
  "services.label": "Our Products",
  "services.title1": "Battery",
  "services.title2": "Solutions",
  "services.description": "High-performance lithium battery systems engineered for reliability across every industry",
  "services.evaluation": "Custom Lithium Battery Modules",
  "services.evaluationDesc": "All battery modules are custom-designed and developed according to customer requirements, including voltage, capacity, size, communication, and application needs. Using advanced LiFePO4 technology, our solutions provide high safety, long lifecycle, reliable performance, and smart BMS protection for telecom, industrial, renewable energy, and backup power applications.",
  "services.dueDiligence": "Telecom Backup Systems",
  "services.dueDiligenceDesc": "Advanced lithium battery backup solutions designed for telecom infrastructure to ensure uninterrupted power during outages and unstable grid conditions. Our systems are built with integrated 2 dry contacts, smart BMS protection, TFT display for real-time monitoring and controlling, and IoT-based remote monitoring for system status, alarms, battery health, and performance tracking. Fast charging capability, high reliability, and modular scalable design make the system suitable for telecom towers, network rooms, and critical communication applications.",
  "services.activeManagement": "Industrial & Forklift Batteries",
  "services.activeManagementDesc": "High-performance lithium battery solutions designed for forklifts, golf carts, and industrial equipment, delivering reliable power, fast charging, high productivity, and high amp discharging capacity for heavy-load operations. Our maintenance-free systems provide longer operating life, improved efficiency, smart BMS protection, and stable performance for demanding industrial and mobility applications.",
  "services.valueCreation": "Energy Storage Systems (ESS)",
  "services.valueCreationDesc": "Advanced energy storage solutions with scalable and modular design for residential, commercial, industrial, and data center applications. Designed for seamless integration with solar systems, smart grids, UPS, and backup power infrastructure, our ESS solutions provide reliable energy management, high efficiency, smart monitoring, and long-lasting LiFePO4 battery performance with fully customizable capacity and features based on customer requirements.",
  "services.forCompanies": "Electric Mobility",
  "services.corporateServices": "E-Scooters & E-Bikes",
  "services.corporateDesc": "Lightweight, durable, and efficient lithium battery systems designed for electric mobility applications, including high-performance bikes. Our solutions provide high energy efficiency, long driving range, fast charging capability, high discharge performance, and reliable operation with customizable capacity, smart BMS protection, and compact design for modern e-scooters and e-bikes.",
  "services.corporate1": "Efficient and eco-friendly mobility solutions",
  "services.corporate2": "Long-lasting battery performance",
  "services.corporate3": "Reliable and high-efficiency power solutions",
  "services.corporate4": "Lightweight and durable battery systems",
  "services.forIndividuals": "BMS Integration",
  "services.entrepreneurSupport": "Smart Monitoring",
  "services.entrepreneurDesc": "Real-time tracking of Voltage, Current, SOC, and SOH with remote IoT-ready monitoring capability.",
  "services.entrepreneur1": "Real-time monitoring and diagnostics",
  "services.entrepreneur2": "Intelligent protection systems",
  "services.entrepreneur3": "CAN Bus & RS485 communication protocols",
  "services.entrepreneur4": "Compatibility with leading inverter systems",
  "services.entrepreneur5": "User-friendly display interfaces",
  "services.learnMore": "Learn More",

  // Projects / Solutions
  "projects.label": "Solutions",
  "projects.title1": "Our",
  "projects.title2": "Capabilities",
  "projects.description": "End-to-end engineering from cell selection to complete system integration across every application",
  "projects.energy.title": "LiFePO4 Battery Systems",
  "projects.energy.desc": "High-energy-efficiency systems achieving 95–98% efficiency through optimized lithium cell chemistry, low internal resistance design, and intelligent BMS-controlled charging.",
  "projects.electronics.title": "Engineering & Design",
  "projects.electronics.desc": "Battery architecture design, BMS integration, electrical design with busbars and connectors, and mechanical enclosure design for durability and thermal control.",
  "projects.construction.title": "Quality Assurance",
  "projects.construction.desc": "Charge & discharge testing, thermal performance testing, load testing under real conditions, and BMS protection verification before every delivery.",
  "projects.viewDetails": "View Details",
  "projects.investmentFocus": "Technology & Safety",
  "projects.investmentFocusDesc": "Advanced safety mechanisms integrated at every level — overvoltage protection, temperature monitoring, thermal management, and hardware-level protection.",
  "projects.viewAll": "View All Solutions",

  // Tags
  "tag.energy": "LiFePO4",
  "tag.batterySystems": "Battery Systems",
  "tag.industrial": "Industrial",
  "tag.electronics": "BMS",
  "tag.iot": "IoT",
  "tag.smartSystems": "Smart Monitoring",
  "tag.construction": "ESS",
  "tag.infrastructure": "Telecom Backup",
  "tag.development": "E-Mobility",

  // Values
  "values.label": "Why Choose Us",
  "values.title1": "Our Core",
  "values.title2": "Strengths",
  "values.description": "Built on precision engineering, safety, and long-term performance reliability",
  "values.integrity": "High Energy Efficiency",
  "values.integrityDesc": "Achieving 98–99.5% efficiency through optimized lithium cell chemistry and intelligent BMS-controlled charging and discharging.",
  "values.longTerm": "Long Lifecycle",
  "values.longTermDesc": "15,000+ charge cycles and 10–15+ years operational lifespan with stable performance and minimal degradation.",
  "values.excellence": "Performance Reliability",
  "values.excellenceDesc": "Engineered to deliver consistent output even under continuous and demanding operational conditions.",
  "values.innovation": "Advanced Safety",
  "values.innovationDesc": "Overvoltage, overcurrent, short-circuit protection, temperature monitoring using NTC sensors, and thermal management.",
  "values.collaboration": "Flexible Customization",
  "values.collaborationDesc": "Flexible voltage and capacity customization, high-current systems up to 300A+, and plug-and-play installation capability.",
  "values.quote": "Quality, safety, and scalability are at the heart of every battery system we design and deliver.",
  "values.quote2": "The energy infrastructure of tomorrow demands systems that never fail — built with precision, driven by innovation, and engineered to outlast every challenge.",

  // CTA
  "cta.label": "Get in Touch",
  "cta.title1": "Power Your",
  "cta.title2": "Operations with Alebel Energy",
  "cta.description": "Whether you need a custom battery solution, telecom backup system, or industrial energy storage, our team is ready to engineer the right solution for you.",
  "cta.contactUs": "Contact Us",
  "cta.callNow": "Call Now",
  "cta.phone": "Phone",
  "cta.email": "Email",
  "cta.website": "Website",
  "cta.location": "Location",

  // Footer
  "footer.description": "Powering the infrastructure of tomorrow. We engineer high-performance energy systems built to outlast, outperform, and redefine reliability.",
  "footer.quickLinks": "Quick Links",
  "footer.portfolio": "Solutions",
  "footer.contact": "Contact",
  "footer.aboutUs": "About Us",
  "footer.batteryEnergy": "Custom Lithium Battery Modules",
  "footer.iotSmart": "BMS Integration & Smart Monitoring",
  "footer.infrastructure": "Telecom & Industrial Backup Systems",
  "footer.copyright": "© 2026 ALEBEL Energy. All rights reserved.",
  "footer.privacy": "Privacy Policy",
  "footer.terms": "Terms of Service",

  // Language
  "language": "Language",
  "language.en": "English",
  "language.ar": "العربية",

  // About Page
  "aboutPage.breadcrumb.home": "Home",
  "aboutPage.breadcrumb.about": "About Us",
  "aboutPage.hero.label": "Who We Are",
  "aboutPage.hero.title1": "About",
  "aboutPage.hero.title2": "ALEBEL ENERGY",
  "aboutPage.hero.description": "A UAE-based advanced energy solutions company specializing in the design, engineering, assembly, and supply of high-performance lithium battery modules and energy storage systems.",
  "aboutPage.story.title1": "Our",
  "aboutPage.story.title2": "Story",
  "aboutPage.story.p1": "Alebel Energy is a UAE-based advanced energy solutions company specializing in the design, engineering, assembly, and supply of high-performance lithium battery modules and energy storage systems.",
  "aboutPage.story.p2": "We deliver custom-built energy solutions tailored to meet the operational demands of telecom infrastructure, industrial applications, logistics and material handling, and renewable energy systems.",
  "aboutPage.story.p3": "Based in Dubai, UAE, Alebel Energy operates at the intersection of advanced engineering and real-world energy challenges, offering solutions that are both technically strong and practically efficient.",
  "aboutPage.story.p4": "Our lithium battery systems are designed with a focus on high energy efficiency achieving 95–98%, long lifecycle performance of 15,000+ charge cycles, and consistent performance reliability even under demanding conditions.",
  "aboutPage.story.p5": "With a strong commitment to quality, safety, and scalability, Alebel Energy supports organizations in achieving energy efficiency, operational continuity, and sustainability goals.",
  "aboutPage.established": "Established",
  "aboutPage.process.label": "Our Process",
  "aboutPage.process.title1": "Engineering",
  "aboutPage.process.title2": "Process",
  "aboutPage.process.step1.title": "Requirement Analysis",
  "aboutPage.process.step1.desc": "We begin with a thorough analysis of your power requirements, environment, and operational demands.",
  "aboutPage.process.step2.title": "System Design",
  "aboutPage.process.step2.desc": "Electrical and mechanical design tailored to your specifications — battery architecture, BMS, enclosures.",
  "aboutPage.process.step3.title": "Prototype & Testing",
  "aboutPage.process.step3.desc": "Prototype development followed by rigorous charge/discharge, thermal, and load testing under real conditions.",
  "aboutPage.process.step4.title": "Production & Delivery",
  "aboutPage.process.step4.desc": "Standardized assembly processes, strict quality control, and pre-delivery performance validation.",
  "aboutPage.values.label": "Our Values",
  "aboutPage.values.title1": "Core",
  "aboutPage.values.title2": "Principles",
  "aboutPage.values.integrity": "Quality",
  "aboutPage.values.integrityDesc": "Every system undergoes rigorous testing and quality control before delivery.",
  "aboutPage.values.longTerm": "Safety",
  "aboutPage.values.longTermDesc": "Safety is integrated at every level of design with advanced protection mechanisms.",
  "aboutPage.values.excellence": "Scalability",
  "aboutPage.values.excellenceDesc": "Modular and scalable designs that grow with your operational needs.",
  "aboutPage.values.innovation": "Innovation",
  "aboutPage.values.innovationDesc": "IoT-ready, smart monitoring, and advanced BMS technology in every system.",
  "aboutPage.values.collaboration": "Reliability",
  "aboutPage.values.collaborationDesc": "Consistent output engineered for continuous and demanding operational conditions.",
  "aboutPage.story.label": "Our Mission",

  // Products Page (was Services Page)
  "servicesPage.breadcrumb.home": "Home",
  "servicesPage.breadcrumb.services": "Products",
  "servicesPage.hero.label": "What We Offer",
  "servicesPage.hero.title1": "Our",
  "servicesPage.hero.title2": "Products",
  "servicesPage.hero.description": "High-performance lithium battery systems and energy storage solutions for every industry.",
  "servicesPage.corporate.label": "Battery Systems",
  "servicesPage.corporate.title1": "Custom",
  "servicesPage.corporate.title2": "Battery Solutions",
  "servicesPage.corporate.description": "Fully customizable lithium battery systems designed and assembled to meet your exact voltage, capacity, and operational requirements.",
  "servicesPage.corporate.item1.title": "LiFePO4 Modules",
  "servicesPage.corporate.item1.desc": "Custom lithium battery modules designed for specific voltage and capacity needs",
  "servicesPage.corporate.item2.title": "Telecom Backup",
  "servicesPage.corporate.item2.desc": "Reliable power during outages with fast recharge and modular scalability",
  "servicesPage.corporate.item3.title": "Industrial Batteries",
  "servicesPage.corporate.item3.desc": "High-performance forklift and industrial batteries, maintenance-free",
  "servicesPage.corporate.item4.title": "Energy Storage (ESS)",
  "servicesPage.corporate.item4.desc": "Scalable ESS with solar and smart grid integration",
  "servicesPage.corporate.item5.title": "Cranking Batteries",
  "servicesPage.corporate.item5.desc": "Peak current up to 2000A, customizable for 12V & 24V systems",
  "servicesPage.individual.label": "Electric Mobility",
  "servicesPage.individual.title1": "E-Mobility",
  "servicesPage.individual.title2": "Solutions",
  "servicesPage.individual.description": "Lightweight, efficient, and durable battery systems for electric scooters, bikes, and mobility applications.",
  "servicesPage.individual.item1.title": "E-Scooter Batteries",
  "servicesPage.individual.item1.desc": "Efficient and eco-friendly lightweight battery systems",
  "servicesPage.individual.item2.title": "E-Bike Batteries",
  "servicesPage.individual.item2.desc": "Long-lasting, high-efficiency power for electric bikes",
  "servicesPage.individual.item3.title": "BMS Integration",
  "servicesPage.individual.item3.desc": "Intelligent battery management with real-time monitoring",
  "servicesPage.individual.item4.title": "Smart Monitoring",
  "servicesPage.individual.item4.desc": "IoT-ready real-time tracking of voltage, current, SOC, SOH",
  "servicesPage.individual.item5.title": "Custom Configurations",
  "servicesPage.individual.item5.desc": "Flexible voltage and capacity customization for any application",
  "servicesPage.cta.title1": "Need a",
  "servicesPage.cta.title2": "Custom",
  "servicesPage.cta.title3": "Battery Solution?",
  "servicesPage.cta.description": "Our engineering team is ready to design and deliver the right energy solution for your specific requirements.",
  "servicesPage.cta.button": "Get a Quote",

  // Solutions Page (was Portfolio Page)
  "portfolioPage.breadcrumb.home": "Home",
  "portfolioPage.breadcrumb.portfolio": "Solutions",
  "portfolioPage.hero.label": "Our Capabilities",
  "portfolioPage.hero.title1": "Engineering",
  "portfolioPage.hero.title2": "Excellence",
  "portfolioPage.hero.description": "End-to-end engineering from cell selection to complete system integration across telecom, industrial, logistics, and renewable energy sectors.",
  "portfolioPage.energy.title": "LiFePO4 Battery Architecture",
  "portfolioPage.energy.desc": "Battery architecture design, BMS integration and communication systems, electrical design with busbars and connectors, and mechanical enclosure design for durability and thermal control.",
  "portfolioPage.energy.fullDesc": "Alebel Energy offers full battery architecture design capability for LiFePO4 systems. Our team handles everything from cell selection and module design to BMS integration, electrical design, and thermal management enclosures.",
  "portfolioPage.electronics.title": "Manufacturing Excellence",
  "portfolioPage.electronics.desc": "High-quality component sourcing, standardized assembly processes, strict quality control procedures, and pre-delivery performance validation.",
  "portfolioPage.electronics.fullDesc": "Every Alebel Energy battery system is manufactured using standardized processes and high-quality components. Our strict quality control and pre-delivery validation ensure every unit performs to specification.",
  "portfolioPage.construction.title": "Industry Experience",
  "portfolioPage.construction.desc": "Proven experience in telecom backup power, energy storage systems, industrial battery applications, and commercial and infrastructure projects.",
  "portfolioPage.construction.fullDesc": "Alebel Energy brings deep industry experience across telecom backup power, energy storage systems (ESS), industrial battery applications, and large-scale commercial and infrastructure projects across the UAE and GCC.",
  "portfolioPage.keyFocus": "Key Capabilities:",
  "portfolioPage.sectors.label": "Industries",
  "portfolioPage.sectors.title1": "Markets We",
  "portfolioPage.sectors.title2": "Serve",
  "portfolioPage.sectors.energy": "Telecom",
  "portfolioPage.sectors.technology": "Industrial",
  "portfolioPage.sectors.manufacturing": "Logistics",
  "portfolioPage.sectors.electronics": "Renewable Energy",
  "portfolioPage.sectors.industrial": "E-Mobility",
  "portfolioPage.cta.title1": "Ready to",
  "portfolioPage.cta.title2": "Get Started",
  "portfolioPage.cta.description": "Contact our engineering team to discuss your power requirements and get a custom solution.",
  "portfolioPage.cta.button": "Contact Us",
  "portfolioPage.tags.energy": "LiFePO4",
  "portfolioPage.tags.batterySystems": "Battery Systems",
  "portfolioPage.tags.industrial": "Industrial",
  "portfolioPage.tags.electricMobility": "Electric Mobility",
  "portfolioPage.tags.electronics": "BMS",
  "portfolioPage.tags.iot": "IoT",
  "portfolioPage.tags.smartSystems": "Smart Monitoring",
  "portfolioPage.tags.rfCommunication": "CAN Bus",
  "portfolioPage.tags.construction": "ESS",
  "portfolioPage.tags.infrastructure": "Telecom Backup",
  "portfolioPage.tags.development": "Custom Build",
  "portfolioPage.tags.turnkeyProjects": "Turnkey Solutions",

  // Contact Page
  "contactPage.breadcrumb.home": "Home",
  "contactPage.breadcrumb.contact": "Contact",
  "contactPage.hero.label": "Get in Touch",
  "contactPage.hero.title1": "Contact",
  "contactPage.hero.title2": "Us",
  "contactPage.hero.description": "Ready to discuss your energy requirements? Our engineering team is here to help design the right solution for you.",
  "contactPage.form.title": "Send us a Message",
  "contactPage.form.success": "Thank you! Your message has been sent successfully.",
  "contactPage.form.name": "Full Name",
  "contactPage.form.namePlaceholder": "Your name",
  "contactPage.form.email": "Email Address",
  "contactPage.form.emailPlaceholder": "your@email.com",
  "contactPage.form.company": "Company",
  "contactPage.form.companyPlaceholder": "Your company",
  "contactPage.form.subject": "Subject",
  "contactPage.form.subjectPlaceholder": "Select a subject",
  "contactPage.form.subjectInvestment": "Custom Battery Inquiry",
  "contactPage.form.subjectPartnership": "Partnership Opportunity",
  "contactPage.form.subjectStartup": "Technical Consultation",
  "contactPage.form.subjectGeneral": "General Inquiry",
  "contactPage.form.message": "Message",
  "contactPage.form.messagePlaceholder": "Tell us about your power requirements...",
  "contactPage.form.submit": "Send Message",
  "contactPage.form.sending": "Sending...",
  "contactPage.info.title": "Contact Information",
  "contactPage.info.description": "Whether you need a custom battery solution, technical consultation, or want to learn more about our products, we're here to help.",
  "contactPage.info.phone": "Phone",
  "contactPage.info.email": "Email",
  "contactPage.info.website": "Website",
  "contactPage.info.location": "Location",
  "contactPage.info.locationValue": "Dubai, United Arab Emirates",
  "contactPage.info.locationDesc": "Office No: 501, 5th Floor, Nasco Building, Salah Al Din, Dubai, UAE",
  "contact.address.line1": "Office No 501, 5th Floor,",
  "contact.address.line2": "Nasco Building, Salah Al Din,",
  "contact.address.line3": "Dubai, UAE",
  "contact.address.short": "Office 501, Nasco Building, Salah Al Din, Dubai, UAE",

  // Get a Quote Page (was Invest Page)
  "investPage.hero.label": "Custom Battery Solutions",
  "investPage.hero.title1": "Get",
  "investPage.hero.title2": "A Quote",
  "investPage.hero.description": "Tell us about your power requirements and our engineering team will design the right solution for you.",
  "investPage.form.title": "Quote Request",
  "investPage.form.name": "Full Name",
  "investPage.form.namePlaceholder": "Your name",
  "investPage.form.email": "Email Address",
  "investPage.form.emailPlaceholder": "your@email.com",
  "investPage.form.company": "Company",
  "investPage.form.companyPlaceholder": "Your company",
  "investPage.form.message": "Power Requirements",
  "investPage.form.messagePlaceholder": "Describe your voltage, capacity, and application requirements...",
  "investPage.form.submit": "Request Quote",
  "investPage.form.sending": "Sending...",
  "investPage.form.success": "Thank you! Your quote request has been sent successfully.",
  "investPage.form.close": "Close",
  "investPage.investments.agricultural": "Custom Lithium Battery Modules",
  "investPage.investments.tourist": "Telecom Backup Power Systems",
  "investPage.investments.healthcare": "Industrial & Forklift Batteries",
  "investPage.investments.commercial": "Energy Storage Systems (ESS)",
  "investPage.investments.technological": "BMS Integration Solutions",
  "investPage.investments.energy": "E-Scooter & E-Bike Batteries",
  "investPage.investments.oil": "Cranking Batteries",
  "investPage.investments.industrial": "Smart Monitoring Systems",
  "investPage.investments.educational": "Custom Engineering Consultation",

  // Additional solution tags
  "portfolioPage.rd.title": "Smart Monitoring",
  "portfolioPage.rd.desc": "IoT-Ready Systems",
  "portfolioPage.rd.fullDesc": "Real-time tracking of Voltage, Current, SOC, and SOH. Remote monitoring capability with IoT-ready infrastructure and user-friendly display interfaces.",
  "portfolioPage.robotics.title": "Safety Systems",
  "portfolioPage.robotics.desc": "Advanced Protection",
  "portfolioPage.robotics.fullDesc": "Overvoltage and undervoltage protection, overcurrent and short-circuit protection, temperature monitoring using NTC sensors, and thermal management to prevent overheating.",
  "portfolioPage.device.title": "System Integration",
  "portfolioPage.device.desc": "Seamless Connectivity",
  "portfolioPage.device.fullDesc": "CAN Bus & RS485 communication protocols, compatibility with leading inverter systems, and plug-and-play installation capability for seamless system integration.",
  "portfolioPage.tags.research": "IoT",
  "portfolioPage.tags.innovation": "Smart Monitoring",
  "portfolioPage.tags.robotics": "Safety",
  "portfolioPage.tags.automation": "Protection",
  "portfolioPage.tags.ai": "BMS",
  "portfolioPage.tags.devices": "CAN Bus",
  "portfolioPage.tags.smartTech": "RS485",

  // products page
  "productsPage.breadcrumb.home": "Home",
"productsPage.breadcrumb.products": "Products",
"productsPage.hero.label": "Our Products",
"productsPage.hero.title1": "Battery",
"productsPage.hero.title2": "Solutions",
"productsPage.hero.description": "Where advanced chemistry meets intelligent design. Purpose-built battery systems that outperform, outlast, and adapt to the world's most demanding environments.",
"productsPage.cta.label": "Get Started",
"productsPage.cta.title1": "Need a",
"productsPage.cta.title2": "Custom Solution?",
"productsPage.cta.description": "Our engineering team is ready to design and deliver the right battery solution for your specific requirements.",
"productsPage.cta.contact": "Contact Our Team",
"productsPage.cta.about": "Learn About Us",
"productsPage.getQuote": "Get a Quote",

"product1.name": "Custom Lithium Battery Modules",
"product1.category": "LiFePO4",
"product1.description": "Designed for specific voltage and capacity requirements, our lithium battery modules use advanced LiFePO4 technology for maximum safety, high performance, and long operational lifecycle. Engineered to deliver stable and consistent output in demanding environments, our solutions are suitable for telecom, industrial, mobility, ESS, and backup power applications.",
"product1.f1": "Specific voltage & capacity design",
"product1.f2": "Advanced LiFePO4 chemistry",
"product1.f3": "Long lifecycle performance",
"product1.f4": "Custom BMS integration",
"product1.f5": "High safety and thermal stability",
"product1.f6": "Smart monitoring & communication support",
"product1.f7": "Reliable performance in harsh environments",

"product2.name": "Telecom Backup Systems",
"product2.category": "Telecom",
"product2.description": "Reliable lithium battery backup solutions designed for telecom infrastructure, providing uninterrupted power during outages with fast recharge capability and modular scalability. Built specifically for mission-critical telecom applications, our systems ensure stable network operation with advanced monitoring and smart protection features.",
"product2.f1": "Reliable power during outages",
"product2.f2": "Fast recharge capability",
"product2.f3": "Modular & scalable design",
"product2.f4": "Remote IoT monitoring",
"product2.f5": "Smart BMS protection system",
"product2.f6": "TFT display for monitoring & controlling",
"product2.f7": "CAN Bus & RS485 communication",
"product2.f8": "Built-in 2 dry contacts for alarms and control",

"product3.name": "Industrial & Forklift Batteries",
"product3.category": "Industrial",
"product3.description": "High-performance lithium battery solutions designed for forklifts, industrial equipment, and golf carts, delivering reliable power and high productivity with maintenance-free operation. Engineered for continuous and demanding working environments, our systems provide stable performance, high discharging capacity, and long operational life.",
"product3.f1": "High performance output",
"product3.f2": "High discharging capacity",
"product3.f3": "Maintenance-free operation",
"product3.f4": "Heavy-duty industrial design",
"product3.f5": "Extended cycle life",
"product3.f6": "Fast charging capability",
"product3.f7": "Smart BMS protection system",
"product3.f8": "Reliable operation in demanding environments",

"product4.name": "Energy Storage Systems (ESS)",
"product4.category": "ESS",
"product4.description": "Advanced energy storage solutions with scalable and modular design for commercial, industrial, infrastructure, and data center applications. Designed for seamless integration with solar panels, UPS, and smart grid systems, our ESS solutions deliver reliable and future-ready energy management with intelligent monitoring and long-lasting LiFePO4 battery technology.",
"product4.f1": "Scalable modular design",
"product4.f2": "Solar integration ready",
"product4.f3": "Smart grid compatible",
"product4.f4": "IoT real-time monitoring",
"product4.f5": "High efficiency energy management",
"product4.f6": "Long lifecycle LiFePO4 technology",
"product4.f7": "Customizable capacity and features",
"product4.f8": "Smart BMS protection & communication integration",

"product5.name": "BMS Integration Solutions",
"product5.category": "Smart Systems",
"product5.description": "Advanced Battery Management System (BMS) integration solutions designed for real-time monitoring, diagnostics, and intelligent battery protection. Our systems provide complete visibility and control over battery performance, ensuring safe, stable, and efficient operation across telecom, industrial, ESS, and mobility applications.",
"product5.f1": "Real-time voltage & current tracking",
"product5.f2": "Intelligent protection systems",
"product5.f3": "CAN Bus & RS485 communication protocols",
"product5.f4": "User-friendly TFT display interfaces",
"product5.f5": "IoT remote monitoring & diagnostics",
"product5.f6": "Cell balancing and temperature monitoring",
"product5.f7": "Alarm notifications and fault protection",
"product5.f8": "Custom BMS integration based on application requirements",

"product6.name": "E-Scooters & E-Bikes Batteries",
"product6.category": "E-Mobility",
"product6.description": "Efficient and eco-friendly lithium battery solutions with lightweight and durable designs for electric scooters, e-bikes, and high-performance mobility applications. Engineered for long-lasting performance, reliable power output, fast charging, and high efficiency for modern electric transportation systems.",
"product6.f1": "Lightweight & compact design",
"product6.f2": "Eco-friendly mobility solutions",
"product6.f3": "Fast charging capability",
"product6.f4": "Smart BMS protection system",
"product6.f5": "Long-lasting battery performance",
"product6.f6": "Reliable and stable power output",
"product6.f7": "High discharge performance",
"product6.f8": "Customizable voltage & capacity options",

"product7.name": "Cranking Batteries",
"product7.category": "Cranking",
"product7.description": "High-performance lithium cranking batteries engineered for automotive, marine, and heavy equipment applications requiring reliable high-current delivery. Designed to provide powerful engine starting performance with lightweight construction, fast recharge capability, and long operational life.",
"product7.f1": "Peak current up to 2000A",
"product7.f2": "12V & 24V system options",
"product7.f3": "Customizable capacity design",
"product7.f4": "High cold-crank performance",
"product7.f5": "Fast recharge capability",
"product7.f6": "Lightweight lithium design",
"product7.f7": "Smart BMS protection system",
"product7.f8": "Reliable high-current power delivery",

"product8.name": "Power Tools Battery",
"product8.category": "Power Tools",
"product8.description": "High-performance lithium-ion battery solutions designed for professional power tools requiring reliable and consistent energy delivery. Built with advanced Max Lithium Li-Ion technology, our batteries provide high power output, fast charging, long runtime, and durable performance for demanding industrial and professional applications.",
"product8.f1": "Customisable capacity & voltage",
"product8.f2": "Max Lithium Li-Ion technology",
"product8.f3": "Fast recharge cycles",
"product8.f4": "Compatible with major tool brands",
"product8.f5": "High power output performance",
"product8.f6": "Lightweight and durable design",
"product8.f7": "Smart protection system integration",
"product8.f8": "Long operational lifecycle",

"customCard.alebelenergy": "Alebel Energy",
'customCard.subtitle': 'Open to Full Customization',
'customCard.badge': 'Custom',
'customCard.description': 'Advanced custom battery solutions engineered to meet precise technical and performance requirements — from concept to full-scale production. We specialize in {prismatic}, {pouch}, and {cylindrical} utilizing next-generation lithium battery technologies.',
'customCard.prismatic': 'prismatic cells',
'customCard.pouch': 'pouch cells',
'customCard.cylindrical': 'cylindrical cells',
'customCard.f1': 'Cell architecture & form factor',
'customCard.f2': 'Voltage & capacity specs',
'customCard.f3': 'Lithium chemistry & energy tech',
'customCard.f4': 'Mechanical & enclosure design',
'customCard.f5': 'BMS integration & protocols',
'customCard.f6': 'Thermal management & safety',
'customCard.f7': 'Charge/discharge optimization',
'customCard.f8': 'Application-specific certifications',
'customCard.sectors': 'ESS · Electric mobility · Marine · Telecom · Industrial · Robotics · Backup power · OEM',

  "product9.name": "Solid-State Marine Battery Module",
  "product9.category": "Marine & Defense",
  "product9.description": "Advanced solid-state LiFePO₄ battery modules engineered for high-performance marine and defense applications. Solid-state cell technology delivers higher safety standards, superior thermal stability, and reliable performance in harsh marine and military environments — where conventional lithium batteries cannot meet the demands.",
  "product9.f1": "Solid-State LiFePO₄ Cell Technology",
  "product9.f2": "12V / 24V / 48V Configurations",
  "product9.f3": "Capacity Customisable",
  "product9.f4": "IP67 Waterproof Protection Grade",
  "product9.f5": "Up to 2000A Peak Current (0–60s)",
  "product9.f6": "Lightweight & Compact Design",
  "product9.f7": "Built-in Smart BMS Protection",
  "product9.f8": "High Thermal Stability & Safety",

  'nav.companyProfile': 'Company Profile',
  'contactPage.form.mobile': 'Mobile Number',

};

export default common;